var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:error-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1667 27.4998H23.8333V31.1665H20.1667V27.4998ZM20.1667 12.8332H23.8333V23.8332H20.1667V12.8332ZM22 3.6665C11.8617 3.6665 3.66666 11.9165 3.66666 21.9998C3.66666 26.8621 5.59821 31.5253 9.03637 34.9635C10.7388 36.6659 12.7598 38.0163 14.9841 38.9376C17.2084 39.859 19.5924 40.3332 22 40.3332C26.8623 40.3332 31.5255 38.4016 34.9636 34.9635C38.4018 31.5253 40.3333 26.8621 40.3333 21.9998C40.3333 19.5923 39.8591 17.2083 38.9378 14.984C38.0165 12.7597 36.666 10.7386 34.9636 9.03621C33.2612 7.33381 31.2402 5.98338 29.0159 5.06205C26.7916 4.14071 24.4076 3.6665 22 3.6665ZM22 36.6665C18.1102 36.6665 14.3796 35.1213 11.6291 32.3707C8.87856 29.6202 7.33333 25.8897 7.33333 21.9998C7.33333 18.11 8.87856 14.3795 11.6291 11.6289C14.3796 8.8784 18.1102 7.33317 22 7.33317C25.8898 7.33317 29.6204 8.8784 32.3709 11.6289C35.1214 14.3795 36.6667 18.11 36.6667 21.9998C36.6667 25.8897 35.1214 29.6202 32.3709 32.3707C29.6204 35.1213 25.8898 36.6665 22 36.6665Z",
    fill: "#F51B47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutline);
export default __webpack_public_path__ + "static/media/error-outline.2e0ee8a9390734dd3cb3830292db1399.svg";
export { ForwardRef as ReactComponent };